// import React from 'react';

//image size should be 1200 × 661

import { dmInfoIconImg, dmQuestionImg, dmResultImg, dmResultDetailsImg, dmStartPageImg } from "../img/projImgsObj.js";

const decisionMakingToolProject = {
  title: "Decision Making Tool",
  shortTitle: "decisionmaking",
  description:
    "Interactive tool walking users through selecting a medical plan.",
  heroImage: dmStartPageImg,
  previewImg: dmQuestionImg,
  skills: ["CSS3", "JS/ES6"],
  introText: [
    {
      index: 0,
      text: "This interactive tool leverages Tivian's survey technology to guide end-users through the process of selecting a medical plan. The brief questionnaire gathers information about the user's typical medical plan needs, and ultimately suggests one of the company's medical plan offerings.",
    },
    {
      index: 1,
      text: "For this project, I worked with the Product team, a Lead Designer, and a medical plan content specialist. This asset was based on an existing video, which we transformed into this more dynamic, personalized experience.",
    },
  ],
  imgsParas: [
    {
      index: 0,
      img: dmInfoIconImg,
      text: "Each question is accompanied by a brief explanation of why the question is being asked, so that users have a comprehensive understanding of how various factors may influence their medical plan selection."
    },
    {
      index: 1,
      img: dmResultImg,
      text: "The end result of the tool is a suggestion for which of the company's medical plans the user could consider. This is calculated with Tivian's back-end survey variables, and displayed to the user as a placement between two plan types."
    },
    {
      index: 2,
      img: dmResultDetailsImg,
      text: "The result page also shows details of various aspects to keep in mind when selecting a medical plan. At the end of the experience, the user can start over, or return to Tivian's main platform.",
    },
  ],
  optstyles: "dropshadow",
};

export default decisionMakingToolProject;
